// TODO: remove ts-nocheck and fix warnings and errors on this file
// @ts-nocheck
import { SaneImage } from '@components';

export function Attribution({ authors }) {
  const nameList = authors.map(x => x.name);
  const names = new Intl.ListFormat('en').format(nameList);

  return (
    <div className="border-1 border-t border-gray-200">
      <div className="mt-6 text-base font-semibold text-gray-700">
        Thanks to the contributors
      </div>
      <div className="mt-1 flex flex-wrap">{names}</div>
      <div className="mt-4 mb-10 flex flex-wrap sm:w-full">
        {authors.map(author => {
          return (
            <div key={author.name} className="mb-3 flex flex-row ">
              <div className="mr-3 flex-shrink-0">
                <span className="sr-only">{author.name}</span>
                <SaneImage
                  className="block h-10 w-10 rounded-md"
                  src={author.picture}
                  height={48}
                  width={48}
                  quality={100}
                  display="fixed"
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
